/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bus': {
    width: 484.5,
    height: 484.5,
    viewBox: '0 0 484.5 484.5',
    data: '<path pid="0" d="M38.25 357c0 22.95 10.2 43.35 25.5 56.1V459c0 15.3 10.2 25.5 25.5 25.5h25.5c15.3 0 25.5-10.2 25.5-25.5v-25.5h204V459c0 15.3 10.2 25.5 25.5 25.5h25.5c15.3 0 25.5-10.2 25.5-25.5v-45.9c15.3-12.75 25.5-33.149 25.5-56.1V102c0-89.25-91.8-102-204-102s-204 12.75-204 102v255zm89.25 25.5c-20.4 0-38.25-17.85-38.25-38.25S107.1 306 127.5 306s38.25 17.85 38.25 38.25-17.85 38.25-38.25 38.25zm229.5 0c-20.4 0-38.25-17.85-38.25-38.25S336.6 306 357 306s38.25 17.85 38.25 38.25S377.4 382.5 357 382.5zm38.25-153h-306V102h306v127.5z"/>'
  }
})
